import { createContext } from 'react';

export interface AuthContextType {
  isLoading: boolean;
  isAuthenticated: boolean;
}

export const AuthContext = createContext<AuthContextType | null>(null); 